import { MyAccountBasicMyTripFragment } from "generated/graphql";
import {
    AccountPushToAppCardLocalization,
    AccountPushToAppCardCopy,
} from "./types";

export const toCopy = (
    l10n: AccountPushToAppCardLocalization,
): AccountPushToAppCardCopy => {
    return {
        pageTitle: l10n.pageTitle.l(),
        textCardTitle: l10n.textCardTitle.l(),
        textCardIconLight: l10n.textCardIconLight.l(),
        textCardIconDark: l10n.textCardIconDark?.l(),
        textCardBody: l10n.textCardBody.l(),
        textCardButton: l10n.textCardButton.l(),
        textCardQuietButton: l10n.textCardQuietButton?.l(),
        textCardQuietButtonLink: l10n.textCardQuietButtonLink?.l(),
        zendeskQuery: l10n.zendeskQuery?.l(),
        zendeskHeader: l10n.zendeskHeader?.l(),
    };
};

export const copyOverrides = (
    slug: string,
    trip: MyAccountBasicMyTripFragment,
): Partial<AccountPushToAppCardCopy> => {
    switch (slug) {
        case "entry-requirements":
            return {
                textCardQuietButtonLink: `/entry-requirements?tour-code=${
                    trip.departure?.tourCode ?? ""
                }`,
            };
        default:
            return {};
    }
};

export const getPushToAppCardCopy = (
    slug: string,
    trip: MyAccountBasicMyTripFragment,
    l10n: AccountPushToAppCardLocalization | null,
): AccountPushToAppCardCopy | null => {
    if (!l10n) {
        return null;
    }

    return {
        ...toCopy(l10n),
        ...copyOverrides(slug, trip),
    };
};
